import { PageUrl } from "src/routes/PageUrl";
import { zUid, ZUid } from "src/types/zUid";
import { z } from "zod";

export const viewType = [
  "bigGroup",
  "bigLink",
  "smallGroup",
  "smallLink",
] as const;
export const zViewType = z.enum(viewType);
export type ZViewType = z.infer<typeof zViewType>;

export const zTextMenuItem = z.object({
  type: z.literal("text"),
});

export const zFilterRestriction = z.object({
  filterAttrId: zUid,
  filterValueStr: z.string(),
});

export const zObjectMenuLink = z.object({
  type: z.literal("object"),
  objectId: zUid,
  filterRestriction: zFilterRestriction.optional(),
});

export type ZObjectMenuLink = z.infer<typeof zObjectMenuLink>;

export const internalMenuLinkUrls = Object.values(PageUrl).filter(
  (url) => !url.includes(":"),
) as [string, ...string[]];

export const zInternalMenuLink = z.object({
  type: z.literal("internal"),
  url: z.enum(internalMenuLinkUrls),
});

export const zExternalMenuLink = z.object({
  type: z.literal("external"),
  href: z.string().regex(/^https?:\/\//),
});

export const zMenuLink = z.discriminatedUnion("type", [
  zTextMenuItem,
  zObjectMenuLink,
  zInternalMenuLink,
  zExternalMenuLink,
]);
export type ZMenuLink = z.infer<typeof zMenuLink>;

export interface ZMenuItem {
  viewType: ZViewType;
  name: string;
  id: number;
  iconName?: string;
  link: ZMenuLink;
  elements?: ZMenuItem[];
  roleIds?: ZUid[];
}

export const zMenuItemLight = z.object({
  viewType: zViewType,
  name: z.string(),
  id: z.number(),
  link: zMenuLink,
  iconName: z.string().optional(),
  roleIds: zUid.array().optional(),
});
export type ZMenuItemLight = z.infer<typeof zMenuItemLight>;

export const zMenuItem: z.ZodType<ZMenuItem> = z.lazy(() =>
  z
    .object({
      elements: zMenuItem.array().optional(),
    })
    .merge(zMenuItemLight),
);
